/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CheckProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Check: React.FC<CheckProps> = ({size, ...props}) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={ size || "20" } height={ size || "20" } {...props}>
    <path d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
      fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
  </svg>
);
Check.displayName = 'Check';
export default Check;
/* tslint:enable */
/* eslint-enable */
